import React from "react";
import { Check, Minus } from "lucide-react";

export const CarerAuthority = ({ data }) => {
    if (!data) return null;
    const cols = data.permission_columns || [];
    const roles = data.roles || [];

    return (
        <section className="panel" data-testid="carer-authority">
            <div className="px-6 sm:px-8 py-5 border-b hairline">
                <p className="mono-label">Governance extension · 02</p>
                <h2
                    className="font-serif mt-1"
                    style={{ fontSize: 28, letterSpacing: "-0.01em" }}
                >
                    {data.title}
                </h2>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-3 border-b hairline">
                <div className="px-6 sm:px-8 py-5 lg:border-r hairline">
                    <p className="mono-label">Custody</p>
                    <p
                        className="font-serif mt-3"
                        style={{ fontSize: 15, lineHeight: 1.55 }}
                    >
                        {data.car?.custody}
                    </p>
                </div>
                <div className="px-6 sm:px-8 py-5 lg:border-r hairline">
                    <p className="mono-label">Authority</p>
                    <p
                        className="font-serif mt-3"
                        style={{ fontSize: 15, lineHeight: 1.55 }}
                    >
                        {data.car?.authority}
                    </p>
                </div>
                <div className="px-6 sm:px-8 py-5">
                    <p className="mono-label">Receipts</p>
                    <p
                        className="font-serif mt-3"
                        style={{ fontSize: 15, lineHeight: 1.55 }}
                    >
                        {data.car?.receipts}
                    </p>
                </div>
            </div>

            <div className="overflow-x-auto">
                <table
                    className="w-full border-collapse"
                    style={{ fontSize: 13 }}
                    data-testid="carer-authority-matrix"
                >
                    <thead>
                        <tr className="border-b hairline">
                            <th
                                className="text-left px-4 py-3 sticky left-0 bg-white"
                                style={{ minWidth: 230 }}
                            >
                                <span className="mono-label">Role</span>
                            </th>
                            {cols.map((c) => (
                                <th
                                    key={c.key}
                                    className="text-left px-3 py-3"
                                    style={{ minWidth: 110 }}
                                >
                                    <span className="mono-label">{c.label}</span>
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {roles.map((r) => (
                            <tr
                                key={r.key}
                                className="border-b hairline last:border-b-0"
                                data-testid={`role-row-${r.key}`}
                            >
                                <td
                                    className="px-4 py-3 sticky left-0 bg-white"
                                    style={{ fontSize: 14 }}
                                >
                                    {r.label}
                                </td>
                                {cols.map((c) => {
                                    const allowed = !!r.permissions?.[c.key];
                                    return (
                                        <td key={c.key} className="px-3 py-3">
                                            {allowed ? (
                                                <Check
                                                    size={15}
                                                    strokeWidth={1.5}
                                                    style={{ color: "var(--forest)" }}
                                                    aria-label="allowed"
                                                />
                                            ) : (
                                                <Minus
                                                    size={15}
                                                    strokeWidth={1.5}
                                                    style={{ color: "var(--ink-muted)" }}
                                                    aria-label="not allowed"
                                                />
                                            )}
                                        </td>
                                    );
                                })}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            <div className="px-6 sm:px-8 py-4 border-t hairline panel-alt">
                <p className="mono-label" style={{ color: "var(--ink-soft)" }}>
                    Carers and family act within bounded permissions; full clinical
                    record and clinical decision authority require explicit legal
                    authority where applicable.
                </p>
            </div>
        </section>
    );
};

export default CarerAuthority;
